import { useEffect } from 'react'
import CheckCertificateModal from '../../../components/check-certificate-modal/index.jsx'
import {
  Loader,
  LoaderWrapper
} from '../../../components/page-loader/styled-components.js'
import { useMtlsCertificateStore } from '../../../zustand/mtls-certificate/use-mtls-certificate-store.jsx'
import { useCheckCertificateQuery } from '../../../react-query/certificate-modal/query/use-check-certificate-query.jsx'

export const AppMtlsCertWrapper = ({ children, isLoggedIn }) => {
  const { setIsMtlsRequired, isMtlsRequired } = useMtlsCertificateStore()

  const { refetch, isLoading, isSuccess, error } = useCheckCertificateQuery({
    enabled: !!isLoggedIn && isMtlsRequired
  })

  useEffect(() => {
    if (isSuccess) {
      return setIsMtlsRequired(false)
    }
  }, [isSuccess])

  if (isLoading) {
    return (
      <LoaderWrapper>
        <Loader className="loader" />
      </LoaderWrapper>
    )
  }
  if (isLoggedIn && isMtlsRequired) {
    return (
      <CheckCertificateModal
        isSuccess={isSuccess}
        isLoading={isLoading}
        error={error}
        refetch={refetch}
      />
    )
  }

  return children
}
